import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
} from '@angular/core'

import { BrowserPushClient } from '@ti/core/auth/services'
import {
  BrowserFileSaver,
  provideBrowserNetworkStatusProvider,
  WhiteLabelSettingsProvider,
} from '@ti/core/common/services'
import { provideBrowserClipboard } from '@ti/core/common/services/clipboard'
import { provideBrowserExternalLinkOpener } from '@ti/core/common/services/external-link-opener.service'
import { BrowserScreenFacade } from '@ti/core/common/services/screen.facade'
import { provideBrowserServiceWorker } from '@ti/core/common/services/update.manager'
import { provideCustomPreloadingStrategy } from '@ti/core/common/strategies'
import { CONFIG } from '@ti/core/contracts/config'
import { FILE_SAVER } from '@ti/core/contracts/file-saver'
import { PUSH_CLIENT } from '@ti/core/contracts/push'
import { SCREEN_FACADE } from '@ti/core/contracts/screen.facade'
import { provideAppVersion } from '@ti/core/contracts/version'
import { AppInitializer } from '@ti/fleet/shell/app.initializer'
import { FleetAppShellModule } from '@ti/fleet/shell/app-shell.module'
import { FleetWhiteLabelSettingsProvider } from '@ti/fleet/white-label'

import env from '../env'
import { APP_VERSION as version } from '../env/version'

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(FleetAppShellModule),
    provideBrowserServiceWorker(env.serviceWorkerScript ?? `service-worker.${env.envType}.js`, {
      enabled: true,
    }),
    AppInitializer,
    { provide: CONFIG, useValue: env },
    { provide: FILE_SAVER, useClass: BrowserFileSaver },
    { provide: PUSH_CLIENT, useClass: BrowserPushClient },
    { provide: SCREEN_FACADE, useClass: BrowserScreenFacade },
    { provide: WhiteLabelSettingsProvider, useClass: FleetWhiteLabelSettingsProvider },
    provideCustomPreloadingStrategy(),
    provideBrowserClipboard(),
    provideBrowserExternalLinkOpener(),
    provideBrowserNetworkStatusProvider(),
    provideAppVersion(version),
    provideAppInitializer(() => {
      const initializer = inject(AppInitializer)
      return initializer.init()
    }),
  ],
}
